//This file contains redux actions for App_Settings

export const set_language_arabic = ()=>{return {type:"language",language:"ar"}}
export const set_language_english = ()=>{return {type:"language",language:"en"}}

// User metadata actions
export const set_user_metadata = (metadata) => {
    return {
        type: "SET_USER_METADATA",
        payload: metadata
    }
}

export const clear_user_metadata = () => {
    return {
        type: "CLEAR_USER_METADATA"
    }
}